module.exports = __webpack_public_path__ + "img/22.c58dcd32.png";